import * as React from 'react';
import { connect } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { Button, CardLink, Col, Container, Fade, Row, Input } from "reactstrap";
import { Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import { Dispatch } from 'redux';
import { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrashAlt, faTimes, faEdit, faHeadphones, faChevronDown, faChevronUp } from '@fortawesome/free-solid-svg-icons';
import { LoadingSpinnerModal, AudioModal, DABTextBox } from '../../components/dab';
import 'react-date-range/dist/styles.css';
import 'react-date-range/dist/theme/default.css';
import { DateRangePicker } from 'react-date-range';
import ReactPaginate from 'react-paginate';
import moment from 'moment';
import { showAlert  } from '../common/functions';
import { episodeAction } from '../../actions/episodeAction';
import { channelAction } from '../../actions/channelAction';

require('wavesurfer.js');

interface IEpisodeProps {
	dispatch: Dispatch<any>;
	episodeData: any;
	channelData: any;
	channelId: number;
}

const EpisodeList: React.SFC<IEpisodeProps> = ({
	dispatch, episodeData, channelData, channelId }) => {

	const history = useHistory();

	var initDate = new Date();
	var initStartDate = new Date(new Date().setFullYear(initDate.getFullYear() - 2));
	var initEndDate = new Date();
	const initialValue = [{ text: "", value: 0, checked: false }];

	const initialInputValue = {
		startDateUtc: moment(new Date(initStartDate.setFullYear(initDate.getFullYear() - 2))).format(),
		endDateUtc: moment(new Date().toISOString()).format(),
		channelIds: [0],
		pageNumber: 1,
		pageSize: 25,
		sortColumn: "",
		sortDirection: "desc"
	};

	const [formSubmit1, setformSubmit1] = useState(false);
	const [isChannelLoaded, setIsChannelLoaded] = useState(false);
	const [fadeIn, setFadeIn] = useState(false);
	const [selectedId, setSelectedId] = useState(-1);
	const [pageList, setPageList] = useState([1]);
	const [chanList, setChanList] = useState(initialValue);
	const [filterInput, setFilterInput] = useState(initialInputValue);
	const [showModal, setShowModal] = useState(false);
	const [showClearFilter, setShowClearFilter] = useState(false);
	const [showDeleteModal, setShowDeleteModal] = useState(false);
	const [showAudioModal, setShowAudioModal] = useState(false);
	const [audioUrl, setAudioUrl] = useState("");
	const [audioTitle, setAudioTitle] = useState("");
	const [episodeTitle, setEpisodeTitle] = useState("");
	const [channelTitle, setChannelTitle] = useState("");
	const [episodeDate, setEpisodeDate] = useState("");
	const [episodeTypeTitle, setEpisodeTypeTitle] = useState("");
	const [inputEpisodeTitle, setInputEpisodeTitle] = useState("");
	const [isTitleErr, setIsTitleErr] = useState(false);
	const [calendarStartDate, setCalendarStartDate] = useState(new Date());
	const [calendarEndDate, setCalendarEndDate] = useState(new Date());
	const [calendarDateLoaded, setCalendarDateLoaded] = useState(false);
	const [isFilterToRestore, setIsFilterToRestore] = useState(true);
	const [isSelectedValuesToRestore, setIsSelectedValuesToRestore] = useState(false);
	const [isEpisodeLoaded, setIsEpisodeLoaded] = useState(false);
	const [dateValue, setDateValue] = useState({ minDate: '', maxDate: '' });
	const [selChannelId, setSelChannelId] = useState(channelId);
	const [dateRange, setDateRange] = useState([{
		endDate: initEndDate,
		startDate: initStartDate,
		key: 'selection'
	}]);

	const handleLoadShowModal = (value: boolean) => {
		setShowModal(value);
	};

	const handleCloseClick = () => {
		setShowDeleteModal(false);
	}
	
	React.useEffect(() => {
		sessionStorage.removeItem("createEpisode")
		if (!calendarDateLoaded) {
			handleGetCalendarYears();
		}

		if (!isChannelLoaded) {
			dispatch(channelAction.channelGetByfilter());
		}
		var fromPage = sessionStorage.getItem("fromPage");

		if (fromPage && fromPage.trim().toLowerCase() == 'episode' && isFilterToRestore) {
			handleFilterRestore();
		}

		if (selChannelId == 0 && calendarDateLoaded && isChannelLoaded && !isEpisodeLoaded) 
		{
			var input = filterInput;
			var chIdList: number[] = [];
			var cIdListA = chanList.filter(x => x.checked === true).map(function (v) {
					return v.value;
				});
			chIdList = cIdListA;
			input.channelIds = chIdList;
			dispatch(episodeAction.episodeGetByFilter(input));
		}

		if (selChannelId > 0 && isChannelLoaded && !isEpisodeLoaded)
		{
			setShowClearFilter(true);
			var input = filterInput;
			input.channelIds[0] = channelId;
			dispatch(episodeAction.episodeGetByFilter(input));
		}		
		setShowModal(true);
	}, [filterInput,isChannelLoaded]);

	const handleToggle = () => setFadeIn(!fadeIn);

	const handleFilterClear = () => {
		setShowClearFilter(false);
		sessionStorage.removeItem("Filter")
		sessionStorage.removeItem("fromPage")
		sessionStorage.removeItem("dateValue")
		var input = initialInputValue;
		input.startDateUtc = moment(dateRange[0].startDate).format("YYYY-MM-DD");
		input.endDateUtc = moment(dateRange[0].endDate).format("YYYY-MM-DD");
		var chIdList: number[] = [];
		chanList.forEach((data) => { data.checked = true });
		setChanList(chanList);
		var cIdListA = chanList.map(function (v) {return v.value;});
		chIdList = cIdListA;
		input.channelIds = chIdList;
		setFilterInput(input);
		localStorage.removeItem("channelId");
		setSelChannelId(0);
		setIsEpisodeLoaded(false);
	}

	const handleFilter = () => {
		localStorage.removeItem("channelId");
		setSelChannelId(0);
		channelId = 0;
		var input = filterInput;
		var chIdList: number[] = [];
		if (channelId === 0) {
			var cIdListA = chanList.filter(x => x.checked === true).map(function (v) {
				return v.value;
			});
			chIdList = cIdListA;
		}
		input.channelIds = chIdList;
		input.startDateUtc = moment(dateRange[0].startDate).format("YYYY-MM-DD");
		input.endDateUtc = moment(dateRange[0].endDate).format("YYYY-MM-DD");
		input.pageNumber = 1;

		setFilterInput({
			...filterInput,
			channelIds: chIdList,
			startDateUtc: moment(dateRange[0].startDate).format("YYYY-MM-DD"),
			endDateUtc: moment(dateRange[0].endDate).format("YYYY-MM-DD"),
			pageNumber:1
		});
		setIsEpisodeLoaded(false);
		handleToggle();
		setShowClearFilter(true);
	};

	const handleSort = (sortColumn) => {
		var input = filterInput;
		var sDir = "asc"
		if (input.sortColumn === sortColumn) {
			if (input.sortDirection === "desc") {
				sDir = "asc";
			}
			else {
				sDir = "desc";
			}
		}
		setFilterInput({
			...filterInput,
			sortColumn: sortColumn,
			sortDirection: sDir
		})
		setIsEpisodeLoaded(false);
		input.sortColumn = sortColumn;
		input.sortDirection = sDir;
	};

	const handleSetPageNumber = (pageNo) => {		
			var input = filterInput;
			setFilterInput({
				...filterInput,
				pageNumber: pageNo,
			});
			setIsEpisodeLoaded(false);
			input.pageNumber = pageNo;
	};

	const handleSortIcon = (sortColumn) => {
		var input = filterInput;
		if (input.sortColumn === sortColumn) {
			if (input.sortDirection === "desc") {
				return <FontAwesomeIcon className='column-sort-icon' icon={faChevronUp} />
			}
			else {
				return <FontAwesomeIcon className='column-sort-icon' icon={faChevronDown} />
			}
		}
	}

	const handleChannelUpdate = (value, checked) => {
		chanList.forEach((data) => {
			if (data.value === value) {
				data.checked = checked;
			}
		});
		setChanList(chanList);
		setformSubmit1(!formSubmit1);
	};

	const handleAllSelect = (e) => {
		chanList.forEach((data) => data.checked = e.target.checked);
		setChanList(chanList);
		setformSubmit1(!formSubmit1);
	}

	const handleInputChange = (event) => {
		let value = event.target.value;
		setIsTitleErr(false);
		setInputEpisodeTitle(value);
	};

	if (channelData && channelData.isListSuccess && !isChannelLoaded) {
		if (channelData.items && channelData.items.length > 0)
		{
			var list: any[] = [];
			var checkedValue = true;
			channelData.items.forEach((data) =>
			{
				if (channelId > 0)
				{
					if (data.channelId == channelId)
					{
						checkedValue = true;
					}
					else
					{
						checkedValue = false;
					}
				}
				var item = { text: data.title, value: data.channelId, checked: checkedValue };
				list.push(item);
			});
			setChanList(list);
		}
		setIsChannelLoaded(true);
	}

	if (showModal && !episodeData.isLoading && !isEpisodeLoaded) {
		if (episodeData.isListSuccess) {
			setIsEpisodeLoaded(true);
			episodeData.isListSuccess = false;
			setShowModal(false);
			var total: number = episodeData.totalCount;
			var pList: number[] = [];
			if (total > 25) {
				for (var i = 1; i < (total / 25); i++) {
					pList.push(i);
				}
				if ((total % 25) > 0) {
					pList.push((parseInt((total / 25).toString()) + 1));
				}
			}
			else {
				pList.push(1);
			}
			setPageList(pList);
		}
	}

	const handleGetCalendarYears = () => {
		var minDateValue = "01/01/" + (new Date().getFullYear());
		var maxDateValue = "31/12/" + (new Date().getFullYear() + 1);
		setCalendarStartDate(new Date(minDateValue));
		setCalendarEndDate(new Date(maxDateValue));
		dispatch(episodeAction.episodeGetMinDate());
	}

	const handleStoreFilterValues = () => {
		var cIdList = chanList.filter(x => x.checked === true).map(function (v) { return v.value});
		initialInputValue.channelIds = cIdList;
		initialInputValue.startDateUtc = moment(calendarStartDate).format("YYYY-MM-DD");
		initialInputValue.endDateUtc = moment(calendarEndDate).format("YYYY-MM-DD");
		var input = filterInput;
		input.startDateUtc = moment(input.startDateUtc).format("YYYY-MM-DD");
		input.endDateUtc = moment(input.endDateUtc).format("YYYY-MM-DD");
		if (JSON.stringify(initialInputValue) != JSON.stringify(input)) {
			sessionStorage.setItem("Filter", JSON.stringify(filterInput));
		}
		sessionStorage.setItem("fromPage", "episode");
		setIsFilterToRestore(false);
	}
	
	const handleRemoveFilterValues = () => {
		sessionStorage.removeItem("Filter");
		sessionStorage.removeItem("fromPage");
	}

	const handleFilterRestore = () => {
		setIsFilterToRestore(false);
		var episodeFilter = sessionStorage.getItem("Filter");

		if (episodeFilter != null && episodeFilter.trim() != "") {
			var episodeFilterObj = initialInputValue;
			episodeFilterObj = JSON.parse(episodeFilter.toString());
			var channelIds = episodeFilterObj.channelIds;
			if (episodeFilterObj != null) {				
				setShowClearFilter(true);
				setDateRange([{ endDate: new Date(episodeFilterObj.endDateUtc), startDate: new Date(episodeFilterObj.startDateUtc), key: 'selection' }])
				setCalendarStartDate(new Date(episodeFilterObj.startDateUtc));
				setCalendarEndDate(new Date(episodeFilterObj.endDateUtc));
				setFilterInput(episodeFilterObj);
				setIsEpisodeLoaded(false);
				setCalendarDateLoaded(true);
				setIsSelectedValuesToRestore(true);
			}
		}
	}

	if (!calendarDateLoaded && episodeData && episodeData.isSuccess && episodeData.minDate && episodeData.minDate != "") {		
		setCalendarStartDate(new Date(episodeData.minDate));
		setCalendarEndDate(new Date(episodeData.maxDate));
		setCalendarDateLoaded(true);
		episodeData.isSuccess = false;
		setFilterInput({
			...filterInput,
			startDateUtc: moment(episodeData.minDate).format("YYYY-MM-DD"),
			endDateUtc: moment(episodeData.maxDate).format("YYYY-MM-DD")
		});
		setIsEpisodeLoaded(false);
		setDateValue({ minDate: moment(episodeData.minDate).format("YYYY-MM-DD"), maxDate: moment(episodeData.maxDate).format("YYYY-MM-DD") })
		setDateRange([{endDate: new Date(episodeData.maxDate),startDate: new Date(episodeData.minDate),key: 'selection'}])
	}

	if (selectedId >= 0 && episodeData.isSuccess && episodeData.isDeleteCompleted && !episodeData.isError) {
		showAlert(episodeData.status, false);
		episodeData.isSuccess = false;
		episodeData.isDeleteCompleted = false;
		setIsEpisodeLoaded(false);
		dispatch(episodeAction.episodeGetByFilter(filterInput));
		setSelectedId(-1);
	}

	if (!episodeData.isSuccess && episodeData.isError) {
		if (episodeData.status === 'Unauthorized') {
			history.push("/401");
		} else {
			showAlert(episodeData.status, true);
		}
		if (showModal) {
			setShowModal(false);
		}
		setSelectedId(-1);
		episodeData.isError = false;
		episodeData.isDeleteCompleted = false;
	}

	const handleDeleteModal = () => {
		if (episodeTitle.toLowerCase() == inputEpisodeTitle.toLowerCase()) {
			setIsTitleErr(false);
			dispatch(episodeAction.episodeDelete(selectedId));
			setShowModal(true);
			setShowDeleteModal(false);
		}
		else {
			setIsTitleErr(true);
		}
	};

	const handleSelectForDelete = (id: number, channelTitle: string, publishAtUtc: string, title: string, episodeTypeTitle: string) => {
		setChannelTitle(channelTitle);
		setEpisodeDate(new Date(publishAtUtc).toLocaleDateString());
		setEpisodeTitle(title);
		setEpisodeTypeTitle(episodeTypeTitle);
		setIsTitleErr(false);
		setInputEpisodeTitle("");
		setSelectedId(id);
		setShowDeleteModal(true);
	}

	const handleUpdateAudioModal = () => {
		setAudioUrl("");
		setShowAudioModal(false);
	};

	const handleSelectForAudio = (id: string, title: string) => {
		setAudioUrl(id);
		setAudioTitle(title);
		setShowAudioModal(true);
	}

	const handleCreateNew = () => {
		window.location.href = "/episode?page=add";
	}

	const handleGetSortColumn = (display, value) => {
		return <div className='column-div' onClick={(e) => { handleSort(value); }}>
			{display} 
			{value === filterInput.sortColumn && (handleSortIcon(value))}
		</div>
	}

	if (isSelectedValuesToRestore && isChannelLoaded) {
		setIsSelectedValuesToRestore(false);		
		if (filterInput != null) {
			var input = filterInput;
			var startDateParsed = input.startDateUtc;
			var endDateParsed = input.endDateUtc;
			var endDateValue = (new Date());
			var startDateValue = (new Date());
			var pageNumber = input.pageNumber;

			if (endDateParsed != "" || endDateParsed != null) {
				endDateValue = (new Date(endDateParsed));
			}

			if (startDateParsed != "" || startDateParsed != null) {
				startDateValue = (new Date(startDateParsed));
			}

			setDateRange([{
				endDate: endDateValue,
				startDate: startDateValue,
				key: 'selection'
			}]);

			if (filterInput.channelIds && filterInput.channelIds.length > 0) {
				var channelIds = filterInput.channelIds;
				if (chanList.length > 0) {
					var list: any[] = [];
					var id = -1;
					var chanIdExists = false;
					chanList.forEach((data) => {
						id = data.value;
						if (channelIds.indexOf(id) > -1) {
							chanIdExists = true;
						}
						else {
							chanIdExists = false;
						}

						var item = { text: data.text, value: data.value, checked: chanIdExists };
						list.push(item);
					});
					setChanList(list);
				}
			}
		}
		handleRemoveFilterValues();
	}

	return (
		<div className="episode-list">
			<div className='card-box'>
				<Row className='filter-link-container'>
					<Col lg="8" className='column'>
						<CardLink onClick={handleToggle} className='card-box-link'>Filter List</CardLink>
						{showClearFilter ?
							<CardLink onClick={handleFilterClear} className='card-box-link-filter'>Clear Filter</CardLink>
							: <CardLink className='card-box-link-filter-disabled'>Clear Filter</CardLink>}
					</Col>
					<Button id="submit" data-testid="createNewEpisode" className="btn-submit-frm" onClick={() => { handleCreateNew(); }}>Create New</Button>
				</Row>
				{fadeIn && (
					<Fade in={fadeIn} tag="h5" className='card-fade'>
						<Container className='filter-container'>
							<div className='box-container'>
									<div>
										<Row >
											<Col lg="11">
												<label className="filter-title">Channels</label>
												<div className="channel-list">
													<div className="all-select filterRow">
														<Input type="checkbox" className='box-container-input'
															checked={chanList.every((item) => item.checked === true)}
															onChange={handleAllSelect} />
														Select All
													</div>
													<Row xs="4">
														{chanList && chanList.map((data: any) =>
															<Col lg="3" key={data.value} className='filterRow'>
																<Input type="checkbox" className='box-container-input' name={data.text}
																	checked={data.checked} onChange={(e) => { handleChannelUpdate(data.value, e.target.checked); }} />
																<span>{data.text}</span>
															</Col>)}
													</Row>
												</div>
											</Col>
											<Col lg="1">
												<div className='close-div'>
													<FontAwesomeIcon data-bs-toggle="tooltip" data-bs-placement="bottom" title="Close"
														size='3x' icon={faTimes} onClick={handleToggle} />
												</div>
											</Col>
										</Row>
									</div>
								<div className="divider-line"></div>
								<Row >
									<Col lg="11">
										<label>Date</label>
										<div >
											<DateRangePicker className=""
												onChange={item => setDateRange([item.selection])}
												showSelectionPreview={false}
												moveRangeOnFirstSelection={false}
												months={2}
												ranges={dateRange}
												direction="horizontal"
												minDate={calendarStartDate}
												maxDate={calendarEndDate}
											/>;
										</div>
									</Col>
									<Col lg="1">
										<Button id="submit" className="inner-filter-link" onClick={() => { handleFilter(); }}>Filter</Button>
									</Col>
								</Row>
							</div>
						</Container>
					</Fade>)}
			</div>
			<div className="episode-table">
				<table className="table table-hover" data-testid="episodeTable">
					<thead data-testid="episodeTableHead">
						<tr>
							<th scope="col" data-testid="detail-th">Details</th>
							<th scope="col" data-testid="channel-th">{handleGetSortColumn("Channel", "Channel")}</th>
							<th scope="col" data-testid="date-th">{handleGetSortColumn("Date", "Date")}</th>
							<th scope="col" data-testid="title-th">{handleGetSortColumn("Title", "Title")}</th>
							<th scope="col" data-testid="bible-th">{handleGetSortColumn("Bible", "Bible")}</th>
							<th scope="col" data-testid="reading-th">{handleGetSortColumn("Reading", "Reading")}</th>
							<th scope="col" data-testid="listen-th">Listen</th>
							<th scope="col" data-testid="delete-th">Delete</th>
						</tr>
					</thead>
					<tbody data-testid="episodeTableBody">
						{
							episodeData && (episodeData.items).map((data: any) =>
								<tr key={data.episodeId} >
									<th scope="row" className="icon-column">
										<a onMouseDown={() => handleStoreFilterValues() }  href={`/episode?id=${data.episodeId}`} className="detail-link" data-testid="episodeDetailButton">
											<FontAwesomeIcon size='2x' icon={faEdit} title="Details" cursor='pointer' className="detailButton" /></a>
									</th>
									<td id="channel"><a href={`/channel?id=${data.channelId}`} className="detail-link" data-testid="channel">{data.channelTitle}</a></td>
									<td id="publish">{new Date(data.publishAtUtc).toLocaleDateString()}</td>
									<td id="title">{data.title}</td>
									<td id="bible"><a href={`/bible?id=${data.bibleId}`} className="detail-link" data-testid="bible">{data.bibleTitle}</a></td>
									<td id="reading"><a href={`/reading?id=${data.readingId}`} className="detail-link" data-testid="reading">{data.readingTitle}</a></td>
									<td className="icon-column">
										<FontAwesomeIcon size='2x' data-testid="listen" icon={faHeadphones} data-bs-toggle="tooltip"
											data-bs-placement="bottom" title="Listen" cursor='pointer'
											onClick={() => {handleSelectForAudio(data.resourceUrl, data.readingTitle) }} />
									</td>
									<td className="icon-column">
										<FontAwesomeIcon size='2x' icon={faTrashAlt} data-bs-toggle="tooltip" cursor='pointer'
											data-bs-placement="bottom" title="Delete" data-testid="episodeDeleteButton" onClick={() => { handleSelectForDelete(data.episodeId, data.channelTitle, data.publishAtUtc, data.title, data.episodeTypeTitle); }} />
									</td>
								</tr>
							)}
						{episodeData && episodeData.items.length <= 0 &&
							<tr className="no-data">
								<th scope="row" colSpan={8}>
									<h4> No data found </h4>
								</th>
							</tr>}
					</tbody>
				</table>
			</div>

			<div className="pagination">
				<ReactPaginate 
					previousLabel={'<<'}
					nextLabel={'>>'}
					breakLabel={'...'}
					pageCount={pageList.length}
					marginPagesDisplayed={2}
					pageRangeDisplayed={10}
					onPageChange={(data) => { handleSetPageNumber(data.selected + 1) }}
					containerClassName={'pagination'}
					pageClassName={"page-item"}
					previousClassName={"page-item"}
					breakClassName={"page-item"}
					breakLinkClassName={"page-link"}
					nextClassName={"page-item"}
					pageLinkClassName={"page-link"}
					previousLinkClassName={"page-link"}
					nextLinkClassName={"page-link"}
					activeClassName={'active'}
					forcePage={ filterInput.pageNumber - 1 }
				/></div>
			{
				showModal && (
					<LoadingSpinnerModal isShowModal={showModal} modalChange={handleLoadShowModal} />
				)
			}
			<AudioModal data-testid="listenAudioModal" isShowModal={showAudioModal} audioUrl={audioUrl} title={audioTitle} modalChange={handleUpdateAudioModal} />
			<Modal isOpen={showDeleteModal} backdrop="static" centered data-testid="deleteModal">
				<ModalHeader className="modal-header" >
					Delete Episode</ModalHeader>
				<ModalBody className="modal-body">
					<form name="deleteEpisodeForm">
						<div className={["row mb-3"].join(" ")}>
							<label data-testid="channelTitle" htmlFor="report" className={["col-sm-3 col-form-label"].join(" ")}>Channel : </label>
							<label data-testid="channelTitleValue" htmlFor="report" className={["col-sm-8 col-form-label"].join(" ")}>{channelTitle} </label>
						</div>
						<div className={["row mb-3"].join(" ")}>
							<label data-testid="date" className={["col-sm-3 col-form-label"].join(" ")}>Date : </label>
							<label data-testid="dateValue" className={["col-sm-8 col-form-label"].join(" ")}>{episodeDate} </label>
						</div>
						<div className={["row mb-3"].join(" ")}>
							<label data-testid="type" className={["col-sm-3 col-form-label"].join(" ")}>Type : </label>
							<label data-testid="typeValue" className={["col-sm-8 col-form-label"].join(" ")}>{episodeTypeTitle} </label>
						</div>
						<div className={["row mb-3"].join(" ")}>
							<label data-testid="title" className={["col-sm-3 col-form-label"].join(" ")}>Title : </label>
							<label data-testid="titleValue" className={["col-sm-8 col-form-label"].join(" ")}>{episodeTitle} </label>
						</div>
						<div className={["row mb-3"].join(" ")}>
							<label data-testid="episodeTitleText" className={["col-sm-5 col-form-label"].join(" ")}>Type Episode Title</label>
							<div className={["col-sm-6"].join(" ")} data-testid="episodeTitleContainer">
								<DABTextBox className={["form-control"].join(" ")} id="episodeTitle" value={inputEpisodeTitle} isRequired={true}
									onChange={(event) => { handleInputChange(event) }} isHover={false} />
								<div style={{ display: `${isTitleErr ? '' : 'none'}` }}><label data-testid="episodeTitleErr" className="text-danger">Typed Episode Title Is Incorrect</label></div>
							</div>
						</div>
					</form>
				</ModalBody>
				<ModalFooter>
					<Button type="button" color="secondary" data-bs-dismiss="modal" onClick={handleCloseClick} data-testid="cancelDeleteButton">Cancel</Button>
					<Button type="button" color="primary" onClick={handleDeleteModal} data-testid="confirmDeleteButton">Confirm Delete</Button>
				</ModalFooter>
			</Modal>
		</div>
	);
};

const mapStateToProps = (state: any) => {
	const { episodeData, channelData } = state;
	return {
		episodeData,
		channelData
	};
};

export default connect(mapStateToProps)(EpisodeList);
